import { useEffect, useRef, useState } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FormCard from "../../components/card/FormCard";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { Form } from "antd";
import FormButton from "../../components/FormButton";
import { $api } from "../../helper";
import { tokenMock } from "../../helper/mock";
import StatusVisit from "../../components/StatusVisit";
import { requireRules } from "../../helper/method";
import { useForm } from "antd/es/form/Form";
import ImageCard from "../../components/card/ImageCard";
import { useNavigate } from "react-router";
import { useNotify } from "../../helper/notify";
import Quill from "quill";

export default function AddTicket() {
  const [form] = useForm();
  const editorRef = useRef<HTMLDivElement | null>(null);
  const quillRef = useRef<Quill | null>(null);
  const notify = useNotify();
  const navigate = useNavigate();
  const { setDashboardName } = useStore(useDashboardName);
  const usersAndCat = $api.useQuery("get", "/site-api/v1/ticket-form/", {
    headers: {
      Authorization: tokenMock,
      lang: "fa",
    },
  });
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/ticket/",
  );
  const [file, setFile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  useEffect(() => {
    setDashboardName("تیکت ها");
    if (!editorRef.current) return;

    if (quillRef.current) return;

    quillRef.current = new Quill(editorRef.current, {
      theme: "snow",
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],
          [{ direction: "rtl" }],
          [{ align: [] }],
          ["link"],
          ["clean"],
        ],
      },
    });
  }, []);

  useEffect(() => {
    if (quillRef.current) {
      quillRef.current.format("align", "right");
      quillRef.current.on("text-change", () => {
        form.setFieldValue(
          "message",
          Number(quillRef.current?.editor.delta.ops[0].insert?.length) <= 1
            ? ""
            : quillRef.current && quillRef.current.root.innerHTML,
        );
      });
    }
  }, [quillRef.current?.editor.getText]);

  const onFinish = (
    values: {
      title: string;
      category_u_id: string;
      users_ids: string[];
      message: string;
    },
    redirect = true,
  ) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("category_u_id", values.category_u_id);
    values.users_ids.forEach((element) => {
      formData.append("users_ids", element);
    });
    formData.append("message", values.message);
    file.forEach((element) => {
      if (element.file) {
        formData.append("files", element.file);
      }
    });
    mutate(
      {
        body: formData,
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      },
      {
        onSuccess: (data) => {
          notify.success(data.message);
          if (redirect) {
            navigate("/ticket");
          } else {
            setTimeout(() => {
              window.location.href = window.location.pathname;
            }, 1000);
          }
        },
      },
    );
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e)}
      layout="vertical"
      className="flex flex-col gap-6"
    >
      <div className="w-full flex justify-between items-center">
        <CustomBreadcrumb
          items={[
            {
              title: "تیکت ها",
              href: "/ticket",
            },
            {
              title: "افزودن تیکت",
            },
          ]}
        />
      </div>
      <FormCard subTitle="اطلاعات تیکت را وارد کنید" title="اطلاعات تیکت">
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-6">
          <FormItemInput
            name={"title"}
            rules={requireRules("عنوان تیکت")}
            className="col-span-1!"
            label="عنوان تیکت"
          />
          <FormItemInputSelect
            name={"category_u_id"}
            rules={requireRules("دسته بندی تیکت")}
            className="col-span-1!"
            label="دسته بندی تیکت"
            inputProps={{
              options: usersAndCat.data?.data.categories.map((e) => ({
                label: (
                  <div className="w-full! flex items-center gap-2 justify-between">
                    <span>{e.title}</span>
                    <StatusVisit status={e.status} />
                  </div>
                ),
                value: e.u_id,
                title: e.title,
              })),
            }}
          />
          <FormItemInputSelect
            name={"users_ids"}
            className="col-span-1!"
            rules={requireRules("انتخاب کاربر")}
            label="کاربران"
            inputProps={{
              mode: "multiple",
              showSearch: {
                optionFilterProp: "label",
              },
              options: usersAndCat.data?.data.users.map((e) => ({
                label: `${e.first_name} ${e.last_name}/ نام پدر : ${e.father_name}`,
                value: e.id,
              })),
            }}
          />
          <Form.Item
            name={"message"}
            label="توضیحات تیکت"
            className="sm:col-span-2! col-span-1!"
            rules={requireRules("توضیحات تیکت")}
          >
            <div
              dir="auto"
              className="w-full border-r border-l border-b border-grayscale-200 h-96! rounded-br-xl rounded-bl-xl"
              lang="fa"
              ref={editorRef}
            />
          </Form.Item>
        </div>
      </FormCard>
      <FormCard
        subTitle="فایل مورد نظر خود را اپلود کنید"
        title="اضافه کردن فایل"
      >
        <ImageCard
          multiple
          pdf
          file={file}
          setFile={setFile}
          id="file-1"
          name="file"
        />
      </FormCard>
      <FormButton
        isPending={isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
